module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_roadbike_12865b45f71dfb5305cc531c00447965.png";